import { Pagination, PaginationProps } from '@amzn/awsui-components-react-v3';
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

export default function TablePagination({
  currentPageIndex,
  pagesCount,
  onPaginationChange,
}: {
  currentPageIndex: number;
  pagesCount: number;
  onPaginationChange: (detail: PaginationProps.ChangeDetail) => void;
}): ReactElement {
  const { t } = useTranslation();
  return (
    <Pagination
      openEnd={false}
      currentPageIndex={currentPageIndex}
      pagesCount={pagesCount}
      ariaLabels={{
        nextPageLabel: t('Next page'),
        previousPageLabel: t('Previous page'),
        pageLabel: (pageNumber) => `Page ${pageNumber} of all pages`,
      }}
      onChange={(e) => onPaginationChange(e.detail)}
    />
  );
}
